// external libraries
import anime from 'animejs';

export default {
    functional: true,
    render: (createElement, context) => {
        // internal props
        const duration = context.props.duration || 500;
        const delay = context.props.delay || 0;
        const data = {
            props: {
                mode: 'out-in',
                css: false,
                duration: {
                    type: [String, Number],
                    default: 2500,
                },
                delay: {
                    type: [String, Number],
                    default: 0,
                },
            },
            on: {
                beforeEnter(el) {
                    
                },
                enter(el) {
                    anime.timeline().add({
                        targets: el,
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: duration,
                        delay: delay,
                    });
                },
                leave(el, done) {
                    anime.timeline().add({
                        targets: el,
                        opacity: [1, 0],
                        easing: 'easeOutExpo',
                        duration: duration,
                    }).complete = done;
                },
            },
        };
        return createElement('transition', data, context.children);
    },
    methods: {
        enter(el) {},
        leave(el, done) {},
    },
};
